export const PROFILE_ABOUT_MAX_LENGTH = 280;
